import React, { Component as C, Children as H } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./toolbar.less"

const themeTypes = {
  default: "default",
  dark: "dark",
}

class Toolbar extends C {
  static propTypes = {
    className: PropTypes.string,
    actions: PropTypes.array,
    align: PropTypes.string,
    space: PropTypes.number,
    theme: PropTypes.string,
  }

  static defaultProps = {
    align: "center",
    theme: themeTypes.default,
  }

  get items() {
    return H.toArray(this.props.children).map((child, i) => {
      return (
        <span
          key={i}
          className={classnames(styles.toolbarItem, child.props.toolbarItemClassName)}
          style={{
            marginRight: `${this.props.space}px` || "5px",
          }}>
          {child}
        </span>
      )
    })
  }

  render() {
    let toolbarClassName = classnames(
      styles.toolbar,
      styles[`${this.props.theme}Theme`],
      {
        [styles.noLayout]: this.props.noLayout,
        [styles.center]: this.props.align === "center",
        [styles.baseline]: this.props.align === "baseline",
      },
      this.props.className,
    )

    return <div className={toolbarClassName}>{this.items}</div>
  }
}
export default Toolbar

Toolbar.themes = themeTypes
